// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billDocumentEntity from './entities/bill-document.json';
import billDocumentMenu from '../pages/bill-document/menu.json';
import billDocumentFullForm from '../pages/bill-document/forms/full.json';
import billDocumentContextForm from '../pages/bill-document/forms/context.json';
import billDocumentMiniForm from '../pages/bill-document/forms/mini.json';
import billDocumentLookupForm from '../pages/bill-document/forms/lookup.json';
import billDocumentTableView from '../pages/bill-document/views/table.json';
import billDocumentCardsView from '../pages/bill-document/views/cards.json';
import billDocumentCalendarView from '../pages/bill-document/views/calendar.json';
import billDocumentDashboardView from '../pages/bill-document/views/dashboard.json';

/** Тип запису «Документ законопроєкту» зі сторінками пакета: меню, форми та подання з pages/bill-document/. */
export const billDocumentDefinition: IRecordTypeDefinition = {
  ...billDocumentEntity,
  views: assembleViewSet({
      table: billDocumentTableView,
      cards: billDocumentCardsView,
      calendar: billDocumentCalendarView,
      dashboard: billDocumentDashboardView,
  }),
  form: billDocumentFullForm,
  forms: { full: billDocumentFullForm, context: billDocumentContextForm, mini: billDocumentMiniForm, lookup: billDocumentLookupForm },
  menu: billDocumentMenu,
} as IRecordTypeDefinition;
